import React from 'react'
import Overlay from 'js/components/Overlay/Overlay'
import Dialog from 'js/components/Dialog/Dialog'

function Modal({ heading, onClose, children }) {
  return (
    <Overlay onOutsideClick={onClose}>
      <Dialog heading={heading} onClose={onClose}>
        {children}
      </Dialog>
    </Overlay>
  )
}

Modal.propTypes = { ...Dialog.propTypes }

export default Modal
